import type { ReactNode } from 'react';
import { AlertTriangleIcon, InfoIcon } from 'lucide-react';

import { Button } from '@/components/atoms';

import './confirm-modal.scss';

type ConfirmModalProps = {
  message: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  isPending?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

function ConfirmModal({
  message,
  confirmLabel,
  cancelLabel = 'Cancel',
  destructive = false,
  isPending = false,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <div className="confirm-modal">
      <div
        className={
          destructive
            ? 'confirm-modal__icon confirm-modal__icon--destructive'
            : 'confirm-modal__icon'
        }
        aria-hidden
      >
        {destructive ? (
          <AlertTriangleIcon size={20} />
        ) : (
          <InfoIcon size={20} />
        )}
      </div>
      <p className="confirm-modal__message">{message}</p>
      <div className="confirm-modal__actions">
        <Button
          type="button"
          variant="info"
          onClick={onCancel}
          disabled={isPending}
        >
          {cancelLabel}
        </Button>
        <Button
          type="button"
          variant={destructive ? 'alert' : 'default'}
          onClick={onConfirm}
          disabled={isPending}
        >
          {isPending ? 'Working…' : confirmLabel}
        </Button>
      </div>
    </div>
  );
}

export { ConfirmModal };
